import React, {useEffect, useState} from "react";
import {Link, useHistory} from "react-router-dom";
import * as Yup from "yup";
import { useFormik } from "formik";
import { toastAlert } from "@paylixecommerce/shared/components";
import { requestMagicLink, getSelfUser } from "services/auth/actions";
import { withGoogleReCaptcha } from "react-google-recaptcha-v3";
import { useDispatch } from "react-redux";
import { Text } from "../../../../components/fields";
import { Button} from "components";
import { useCookies } from "react-cookie";
import { redirectToSubLink } from "../../../../components/subdomainLink";

import "../../index.scss";

export const MagicLinkIcon = ({ purple }) => <svg width="19" height="18" viewBox="0 0 19 18" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M3.875 14.625C4.49632 15.2463 5.50368 15.2463 6.125 14.625L15.125 5.625C15.7463 5.00368 15.7463 3.99632 15.125 3.375V3.375C14.5037 2.75368 13.4963 2.75368 12.875 3.375L3.875 12.375C3.25368 12.9963 3.25368 14.0037 3.875 14.625V14.625Z" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M11.75 4.5L14 6.75" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M7.25 2.25C7.25 2.64782 7.40804 3.02936 7.68934 3.31066C7.97064 3.59196 8.35218 3.75 8.75 3.75C8.35218 3.75 7.97064 3.90804 7.68934 4.18934C7.40804 4.47064 7.25 4.85218 7.25 5.25C7.25 4.85218 7.09196 4.47064 6.81066 4.18934C6.52936 3.90804 6.14782 3.75 5.75 3.75C6.14782 3.75 6.52936 3.59196 6.81066 3.31066C7.09196 3.02936 7.25 2.64782 7.25 2.25Z" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M14.75 9.75C14.75 10.1478 14.908 10.5294 15.1893 10.8107C15.4706 11.092 15.8522 11.25 16.25 11.25C15.8522 11.25 15.4706 11.408 15.1893 11.6893C14.908 11.9706 14.75 12.3522 14.75 12.75C14.75 12.3522 14.592 11.9706 14.3107 11.6893C14.0294 11.408 13.6478 11.25 13.25 11.25C13.6478 11.25 14.0294 11.092 14.3107 10.8107C14.592 10.5294 14.75 10.1478 14.75 9.75Z" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
</svg>



const MagicLink = ({ googleReCaptchaProps: {executeRecaptcha}} ) => {

    const makeCaptcha = () => executeRecaptcha('reset');
    const dispatch = useDispatch();
    const [cookies] = useCookies(['accessToken']);
    const history = useHistory();
    const [isSent, setLinkSent] = useState(false);

    const onSubmit = (data) => {

        makeCaptcha()
            .then((captcha) => {
                data.captcha = captcha;

                dispatch(requestMagicLink(data))
                    .then((res) => {
                        toastAlert('success', res.message);
                        setLinkSent(true);
                    })
                    .catch(err => toastAlert('error', err ? err.error : ""))
            });
    };

    useEffect(() => {

        let interval = null;

        if(isSent) {
            interval = setInterval(() => {
                dispatch(getSelfUser())
                    .then(() => {
                        if(window.close) {
                            window.close();
                        }
                        redirectToSubLink('dashboard', '/', history)
                    });
            }, 2500)
        }

        return () => {
            clearInterval(interval)
        }

    }, [cookies && cookies.accessToken, isSent])

    let initialValues = { email: '' };
    let validationSchema = Yup.object().shape({ email: Yup.string().email('Please enter the valid email').required('Email is required') });
    let form = useFormik({initialValues, onSubmit, validationSchema});

    return <>
        <div className="auth-content">
            <Link to="/login" className="auth-content-logo" style={{ marginBottom: '2.5rem', marginTop: '-1.5rem' }}>
                <img loading="lazy" src="https://cdn.paylix.gg/static/images/images/logo_logo.svg" alt="Paylix Logo" style={{ width: 160, height: "auto" }} />
            </Link>

            <form onSubmit={form.handleSubmit} className="auth-content-form">
                <div className="auth-content-title">Sign in with Magic Link</div>
                <span className="auth-content-details">We'll email you a Magic Link to sign in</span>

                <Text autoComplete="on" label="Email" name="email" {...form} />

                <Button size="large" className="w-100" type="submit">
                    <MagicLinkIcon />&nbsp;&nbsp;Send Magic Link
                </Button>

                <div className="auth-content-subfooter"  style={{ marginTop: "1.5rem", marginBottom: "-0.5rem" }}>
                    <div>Not using Magic Link? <Link to="/login">Go Back</Link></div>
                </div>
            </form>

        </div>

        <span className="auth-content-subfooter">
            <div>Don’t have an account? <Link to="/register">Sign up</Link></div>
        </span>
    </>
}


export default withGoogleReCaptcha(MagicLink)
